/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import ZoneRuleType from 'solis/claude/action/enum/zone.rule.type';


// cpp update_colony_zone_value_args minus `source_user`.
const buildArgs = ({ colony, zone }) =>
{
  const args = {};

  args.galaxy = colony.cass.galaxy;
  args.target_colony = colony.cass.id;
  args.target_zone = zone.getAbsoluteHex().toString();

  return args;
};


// Mirrors update_zone_value.h: a rule the colony cannot afford is dropped before the
// value cost is computed, so it neither charges authority nor shifts the currency cost.
export const calculateCost = (colony, zone) =>
{
  const value = zone.cass.value;

  let rule = zone.cass.rule;
  let authority = 0;

  if (rule !== null)
  {
    authority = rule.value;

    if (colony.cass.authority < authority)
    {
      rule = null;
      authority = 0;
    }
  }

  let currency = value + 1;

  if (rule !== null && rule.type === ZoneRuleType.Penalty)
  {
    currency += rule.value;
  }

  if (rule !== null && rule.type === ZoneRuleType.Incentive)
  {
    currency -= rule.value;
  }

  return { currency: Math.max(1, currency), authority };
};


const validate = ({ colony, zone }) =>
{
  const cost = calculateCost(colony, zone);
  const sector = zone.getSector();

  const issues = [];

  if (sector.cass.currency < cost.currency)
  {
    issues.push('Insufficient currency: need ' + cost.currency + ', have ' + sector.cass.currency);
  }

  return { cost, valid: issues.length === 0, issues };
};


const isAvailable = ({ colony, zone, account }) =>
{
  return zone !== null && !colony.cass.board && zone.getSector().cass.user === account.cass.id;
};


export default
{
  type: 'solis/colony/zone/value/update',
  inputs: {},

  isAvailable,
  buildArgs,
  validate,
};
